// // Sidebar.js
// import React from "react";
// import { FaUserCircle, FaSignOutAlt, FaClipboardList, FaWallet, FaIdCardAlt } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const MobileSidebar = ({ isMenuOpen, menuRef, username, handleSignOut }) => {
//   const navigate = useNavigate();

//   return (
//     isMenuOpen && (
//       <div
//         ref={menuRef}
//         className="md:hidden bg-white absolute top-16 left-0 w-3/4 h-[671px] z-10 shadow-lg"
//       >
//         <div className="flex flex-col space-y-4 p-4 text-xl font-semibold text-gray-700">
//           {username !== "Guest" ? (
//             <>
//               <div className="flex items-center space-x-2 text-lg font-medium">
//                 <FaUserCircle /> <span>{username}</span>
//               </div>
//               <a
//                 href="/"
//                 className="hover:text-indigo-500"
//                 onClick={handleSignOut}
//               >
//                 Logout
//               </a>
//             </>
//           ) : (
//             <a
//               href="/login-signup"
//               className="hover:text-indigo-500"
//               onClick={() => navigate("/login-signup")}
//             >
//               Login or Signup
//             </a>
//           )}
//           <a href="/" className="hover:text-indigo-500">
//             Home
//           </a>
//           <a href="/product" className="hover:text-indigo-500 border-t">
//             Our Fleet
//           </a>
//           <a href="/offers" className="hover:text-indigo-500 border-t">
//             Offers
//           </a>
//           <a href="/franchise" className="hover:text-indigo-500 border-t">
//             Partner with us
//           </a>
//           <a href="/contact" className="hover:text-indigo-500 text-lg font-normal">
//             Contact Us
//           </a>
//           <a href="/blog" className="hover:text-indigo-500 text-lg font-normal">
//             Blog
//           </a>
//           <a href="/about" className="hover:text-indigo-500 text-lg font-normal">
//             FAQ
//           </a>
//         </div>
//       </div>
//     )
//   );
// };

// export default MobileSidebar;


// import React from "react";
// import { FaUserCircle,} from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const MobileSidebarLoggedIn = ({ isMenuOpen, menuRef, username, handleSignOut }) => {
//   const navigate = useNavigate();

//   return (
//     isMenuOpen && (
//       <div
//         ref={menuRef}
//         className="md:hidden bg-white absolute top-16 left-0 w-3/4 h-[671px] z-10 shadow-lg"
//       >
//         <div className="flex flex-col space-y-4 p-4 text-xl font-semibold text-gray-700">
//           <div className="flex items-center space-x-2 text-lg font-medium">
//             <FaUserCircle /> <span>{username}</span>
//           </div>
//           <a
//             href="/"
//             className="hover:text-indigo-500"
//             onClick={handleSignOut}
//           >
//             Logout
//           </a>
//           <a href="/" className="hover:text-indigo-500">
//             Home
//           </a>
//           <a href="/product" className="hover:text-indigo-500 border-t">
//             Our Fleet
//           </a>
//           <a href="/offers" className="hover:text-indigo-500 border-t">
//             Offers
//           </a>
//           <a href="/franchise" className="hover:text-indigo-500 border-t">
//             Partner with us
//           </a>
//         </div>
//       </div>
//     )
//   );
// };

// export default MobileSidebarLoggedIn;

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaUserCircle, FaInstagram, FaLinkedin, FaYoutube, FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

// const MobileSidebarLoggedIn = ({ isMenuOpen, menuRef, handleSignOut }) => {
  const MobileSidebarLoggedIn = ({ isMenuOpen, setIsMenuOpen, menuRef, handleSignOut }) => {
  const navigate = useNavigate();

  // Retrieve the username from Redux store
  const username = useSelector((state) => state.user.username);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen, setIsMenuOpen, menuRef]);
  console.log('username', username);
  return (
    isMenuOpen && (
      <div
        ref={menuRef}
        className="md:hidden bg-white absolute top-16 left-0 w-3/4 h-full z-10 shadow-lg"
      >
        <div className="flex flex-col space-y-2 p-4 text-xl font-semibold text-gray-700">
          <div
            className="flex items-center space-x-2 text-lg font-medium hover:border hover:bg-[#FF9630] hover:text-white rounded-lg p-2 cursor-pointer"
            onClick={() => navigate('/p-sidebar')}
          >
            <FaUserCircle /> <span>{username}</span>
          </div>
          <a href="/" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
            Home
          </a>
          <a href="/product" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
            Our Fleet
          </a>
          <a href="/offers" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
            Offers
          </a>
          <a href="/franchise" className="hover:text-[#FF9630]  border-gray-200 pb-2 mt-4">
            Partner with us
          </a>

          <a href="/franchise" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
            Wallet
          </a>
          <a href="/franchise" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
            My Case
          </a>
          <a href="/franchise" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
            Contact Us
          </a>
          <a href="/franchise" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
            Blog
          </a>
          <a href="/franchise" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
            Faq
          </a>

          <button
            href="/logout"
            className="hover:text-[#FF9630] border p-2 mt-40 rounded-lg"
            onClick={handleSignOut}
          >
            Logout
          </button>
          <div className="flex justify-center items-center space-x-8 mt-40  pb-2 px-4 ">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
              <FaFacebook />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
              <FaInstagram />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
              <FaXTwitter />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
              <FaLinkedin />
            </a>
            <a
              href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl" aria-label="YouTube">
              <FaYoutube />
            </a>

          </div>
        </div>
      </div>
    )
  );
};

export default MobileSidebarLoggedIn;
